/**
 * 
 * 
 */

import React from 'react';
import BotChatBubble from "./../BotChatBubble/BotChatBubble.jsx";
import BotQuestion from './../BotQuestion/BotQuestion.jsx';
import BotQuestionnaireResult from './BotQuestionnaireResult.jsx';
import StateMachine from 'react-simple-state/dist';
import i18n from  "./../../Documental/Localization/i18n.js";
import CodingSystemTranslator from "./../../Documental/View/CodingSystemTranslator.js";
import { DomainResource } from './../../Documental/DomainResource/DomainResource';
const appState = new StateMachine();



class BotQuestionnaire extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      resourcesLoaded : false,
      finishRequested : false,
      resultsScreen : false,
      questionnaire: null,
      forceRenderCnt : 0,
      questionNr : 1
    };

    this.refugeeAnswerLocalResoureId = null;
    this.refugeeAnswerLastValue = '';
    this.refugeeAnswerLastValueCode = '';
    this.refugeeSyncWaitTimer = null;

    this.resourceWaitTimer = null;
    this.guidanceResponseWaitTimer = null;
    this.codingTranslator = new CodingSystemTranslator();
    
    this.moveToNextQuestion = this.moveToNextQuestion.bind( this );
    this.handleQuestionAnswered = this.handleQuestionAnswered.bind( this );
    this.handleMoveBack = this.handleMoveBack.bind( this );
    this.handleFinishRequest = this.handleFinishRequest.bind( this );
  }

  
  componentWillMount() {
    this.setState({
      resourcesLoaded : false,
      questionnaire: null
    });

    this.checkResourcesLoaded();

    
  }


  /**
   * If parent component updates resource 
   * we have to close this session and start all over again 
   * with new questionnaire / QuestionnaireResponse
   * 
   * @param object prevProps 
   */
  componentDidUpdate( prevProps ) {
    if ( this.props.resourceUrl !== prevProps.resourceUrl ) {
      
      if( this.resourceWaitTimer !== null ){
        clearTimeout( this.resourceWaitTimer );
        this.resourceWaitTimer = null;
      }
      
      if( this.guidanceResponseWaitTimer !== null ){
        clearTimeout( this.guidanceResponseWaitTimer );
        this.guidanceResponseWaitTimer = null;
      }

      let force = this.forceRenderCnt + 1;
      this.setState({
        forceRenderCnt : force,
        resourcesLoaded : false,
        questionnaire: null
      });

      // have to add bit delay so setState can finish. Needs better solution - this is quick hack
      var that = this;
      setTimeout( function(){
        that.checkResourcesLoaded();
      }, 300);
    }
  }


  componentDidMount() {
    window.appEventsEmitter.emit( 'rendered', { "eventSource" : "componentQuestionnaire" } );
    
    var that = this;

    var anonymousQuestionnaireResponseUpdated = function( payLoad ){
      that.checkNewQuestionnaireResponseRecieved( payLoad );
    }

    window.appEventsEmitter.addListener( 'entities-updated', anonymousQuestionnaireResponseUpdated );

    // historyandstate
    //window.onhashchange = function( event ) {
    //  that.handleMoveBack();
    //  return false;
    //}

    /*
    var anonymousBackButtonPressed = function(event) {
      // The popstate event is fired each time when the current history entry changes.
  
      var r = confirm("You pressed a Back button! Are you sure?!");
      
      // if (r == true) {
      if( !window.qHolder.canMoveBackwards()  ){
          // Call Back button programmatically as per user confirmation.
          history.back();
          // Uncomment below line to redirect to the previous page instead.
          // window.location = document.referrer // Note: IE11 is not supporting this.
      } else {
          // Stay on the current page.
          that.handleMoveBack();
          history.pushState(null, null, window.location.pathname);
      }
  
      history.pushState(null, null, window.location.pathname);
    }

    // window.addEventListener( 'popstate', anonymousBackButtonPressed, false );
    

    this.listenerQuestionnaireResponseUpdated  = anonymousQuestionnaireResponseUpdated;
    this.listenerBackButtonPressed = anonymousBackButtonPressed;
    */



  }

  
  componentWillUnmount() {
    if( this.resourceWaitTimer !== null ){
      clearTimeout( this.resourceWaitTimer );
      this.resourceWaitTimer = null;
    }
    //window.appEventsEmitter.removeListener( 'entities-updated', this.listenerQuestionnaireResponseUpdated );
    //window.removeEventListener( 'popstate', this.listenerBackButtonPressed, false );
  }

  /**
   * We have to redraw responses if someone respone object is updated from server
   * We expect this as payload: 
   * 
   * {
   *   'source' : 'server', 
   *   'entityTypes' : [
   *     'QuestionnaireResponse'
   *    ] 
   * }
   * 
   * @param object payLoad 
   */
  checkNewQuestionnaireResponseRecieved( payLoad ) {
    var checkQR = false;

    if( payLoad && typeof payLoad.source != 'undefined' && payLoad.source == 'server' ){
      if( typeof payLoad.entityTypes != 'undefined' ){
        for( var i in payLoad.entityTypes ){
          if( payLoad.entityTypes[ i ] == 'QuestionnaireResponse' ){
            checkQR = true;
          }
        }
      }
    }

    if( !checkQR ){
      return;
    }


    console.log( 'QuestionnaireResponse updates from server - check for re-draw' );
  }


  /**
   * There is 2 ways to start work with Questionnaire component
   * 
   *  - starting a brand new Questionnaire answering session
   *  - resuming already started session via QuestionnaireResponse resource
   * 
   * QuestionnaireResponse resource has reference to original Questionnaire
   * For resuming we need both resources to be loaded and ready. 
   * 
   * Load resource requested. If it's QuestionnaireResponse - we need also load 
   * Questionnaire resource referenced from there. After both loaded we an render 
   * questionnaire and continue wehn response (previous answers) are applied. 
   * 
   */
  checkResourcesLoaded(){
    
    if( this.resourceWaitTimer ){
      clearTimeout( this.resourceWaitTimer );
    }

    var drQuestionnaireResponse = null;
    var drQuestionnaire = null;
    var loadQuestionnaireResponse = false;

    var extracted = window.appEntityStore.getResourceIdAndTypeFromUrl( this.props.resourceUrl );
    // console.log( extracted );

    if( extracted.resourceType == "QuestionnaireResponse" ){
      loadQuestionnaireResponse = true;
      var drQuestionnaireResponse = window.appEntityStore.getResourceById( extracted.id );
      if( !drQuestionnaireResponse || drQuestionnaireResponse == null ){
        window.appEntityStore.requestResource( extracted );
      }
    } else {
      var drQuestionnaire = window.appEntityStore.getResourceById( extracted.id );
      if( !drQuestionnaire || drQuestionnaire == null ){
        window.appEntityStore.requestResource( extracted );
      }
    }


    if( loadQuestionnaireResponse && drQuestionnaireResponse ){
      var json = drQuestionnaireResponse.toObject();
      if( typeof json.questionnaire != 'undefined' ){
        var extracted2 = window.appEntityStore.getResourceIdAndTypeFromUrl( json.questionnaire );
        drQuestionnaire = window.appEntityStore.getResourceById( extracted2.id );
        if( !drQuestionnaire || drQuestionnaire == null ){
          window.appEntityStore.requestResource( extracted2 );
        }
      }
    }
    
    
    var that = this;

    var allLoaded = false;

    if( loadQuestionnaireResponse ){
      if( 
        drQuestionnaire && drQuestionnaire != null && 
        drQuestionnaireResponse && drQuestionnaireResponse != null 
      ){
        allLoaded = true;
      }
    } else if ( drQuestionnaire && drQuestionnaire != null ) {
      allLoaded = true;
    }
    
    if ( !allLoaded ) {
      this.setState({
        resourcesLoaded: false,
        patientEntity: null
      });

      //console.log( 'Not all loaded'  );
      // wait for it ....
      this.resourceWaitTimer = setTimeout( function(){
        that.checkResourcesLoaded();
      }, 300);
    } else {

      if( this.state.resourcesLoaded ){
        return;
      }

      this.setupQuestionnaireResources( drQuestionnaire, drQuestionnaireResponse );
      
      var newCnt = this.state.forceRenderCnt + 1;
      
      this.setState({
        resourcesLoaded: true,
        questionnaire : drQuestionnaire.toObject(),
        forceRenderCnt : newCnt
      });
      
    }
  }


  /**
   * 
   * @param DomainResource drQuestionnaire 
   * @param DomainResource drQuestionnaireResponse 
   */
  setupQuestionnaireResources( drQuestionnaire, drQuestionnaireResponse ) {
    
    var isNewQuestionnaireResponse = false;

    var qrStatus = '';
    // create new local entity ID if no QuestionnaireResponse is applied / is new answering session
    if( drQuestionnaireResponse != null ){
      var id = drQuestionnaireResponse.getId();
      qrStatus = drQuestionnaireResponse.getStatus();
    } else {
      var id = window.appEntityStore.createLocalResourceId( "QuestionnaireResponse" );
      isNewQuestionnaireResponse = true;
    }

    let currentAppMode2 = appState.getState( 'app-main-mode' );
    if( currentAppMode2.appMainMode === "app-main-mode-ukrainan" ){
      window.qHolder.setRefugeeQuestion( true ); 
    }
    
    window.qHolder.setQuestionnaireResource( drQuestionnaire.toObject(), id );
    if( qrStatus != '' && qrStatus != null ){
      window.qHolder.setCurrentQuestionnaireResponseStatus( qrStatus );
    }
    
    //apply answers
    if( drQuestionnaireResponse != null ){
      // self-report  window.qHolder.applyQuestionnaireResponseJson( drQuestionnaireResponse.toObject() );
    }
    

    if( isNewQuestionnaireResponse ){
      // add initial answers based on answer hints at moment
      // self.report has no hints
      // window.qHolder.initInitialValues();
    }

    //window.appEventsEmitter.emit( "questionnaire-tab-changed", window.qHolder.getActiveTabNumber() );
    window.appEventsEmitter.emit( 'questionnaire-loaded', { "eventSource" : "componentQuestionnaireBot" } );
  }


  /**
   * LinkId like "SR.1.1" - question link ID
   * Answer in a array like 
   * [
   *   {
   *      "answerCode" : "SR.2.2.1"
   *   },
   *   {
   *      "answerCode" : "SR.2.2.D"
   *   }
   *   ....
   * ]
   * 
   * 
   * @param string questionLinkId 
   * @param array selectedAnswers 
   */
  handleQuestionAnswered( questionLinkId, selectedAnswers ){
    
    if( questionLinkId == 'FAKE.1.1' ){
      let newCnt = this.state.forceRenderCnt + 1;
      let goToResults = false;

      for( var j in selectedAnswers ){
        if( 'FAKE.1.1.A' == selectedAnswers[ j ].answerCode ){
          goToResults = true;
        }
      }

      this.setState({
        forceRenderCnt : newCnt,
        finishRequested : false,
        resultsScreen : goToResults
      });
      
      return;
    }

    // silently remove previous answers given for this question (this is needed when user has navigated back in questions)
    // to give new set of answers set by user
    window.qHolder.clearAnswersForQuestion( questionLinkId );

    for( var j in selectedAnswers ){
      window.qHolder.addAnswer( {
        linkId : questionLinkId
      }, selectedAnswers[ j ].answerCode );
    }

    if( true ){
      this.moveToNextQuestion();
    }
  }


  maybeSendRefugeeAnswer( currentQuestion ){
    if( window.qHolder.isFakeRefugeeQuestion( currentQuestion.questionLinkId ) ){
      let answers = window.qHolder.getAllAnswersForQuestion( currentQuestion );
      let answerYesNo = 'unknown';
      let answerCode = '';
      
      
     // 2025-03	Removed this option issues/66 - moved SR.0.0.99 to "no" option

      for( var i in answers ){
        if( answers[ i ] === 'SR.0.0.1' || answers[ i ] === 'SR.0.0.2' ){
          answerYesNo = 'yes';
        }
        if( answers[ i ] === 'SR.0.0.3' || answers[ i ] === 'SR.0.0.4' || answers[ i ] === 'SR.0.0.99' ){
          answerYesNo = 'no';
        }

        answerCode = answers[ i ];
      }

      this.saveRefugeeAnswer( answerYesNo, answerCode, false );
    }
  }

  /**
   * Should we update or insert? 
   * 
   * @param {*} answerYesNo 
   */
  saveRefugeeAnswer( answerYesNo, answerCode, fromSync ){
    if( this.refugeeAnswerLastValueCode === answerCode && fromSync === false ){
      return;
    }

    this.refugeeAnswerLastValue = answerYesNo;
    this.refugeeAnswerLastValueCode = answerCode;

    let qrJson = this.createRefugeeQuestionResourceJson( answerCode );
    var that = this;

    if( this.refugeeAnswerLocalResoureId === null ){
      // Only first time do it? Not possible to send another answer/change answer?
      var domainResource = new DomainResource( "QuestionnaireResponse" );
      domainResource.setRawResourceObject( qrJson );
      domainResource.setResourceMeta( window.appEntityStore.getResourceMetaWithOnlyNewSourceUrl( 'QuestionnaireResponse' ) );
      this.refugeeAnswerLocalResoureId = window.appEntityStore.createLocalResourceId( "QuestionnaireResponse" );
      domainResource.setId( this.refugeeAnswerLocalResoureId );
      window.appEntityStore.saveResource( domainResource );
      console.log( 'INSERT RF' );
    } else {
      if( !this.isRefugeeQuestionSynced() ){
        if( this.refugeeSyncWaitTimer !== null ){
          clearTimeout( this.refugeeSyncWaitTimer );
          this.refugeeSyncWaitTimer = null;
        }
        this.refugeeSyncWaitTimer = setTimeout( function(){
          that.saveRefugeeAnswer( that.refugeeAnswerLastValue, that.refugeeAnswerLastValueCode, true );
        }, 200 );
      } else {
        let serverId = window.appEntityStore.getMappedServerIdFromLocalId( this.refugeeAnswerLocalResoureId );
        let resource = window.appEntityStore.getResourceById( serverId );
        
        if( resource !== null ){
          // serviceRequest._resourceLiteral
          resource._resourceLiteral.item[0].answer[0].valueString = answerCode;
          console.log( 'UPDATE RF' );
          console.log( resource._resourceLiteral );
          window.appEntityStore.saveResource( resource );
        } else {
          console.log( 'Resource not found for RF update. ' );
        }
      }
    }
  }


  isRefugeeQuestionSynced = () => {
    if( this.refugeeAnswerLocalResoureId === null ){
      return false;
    }
    
    let serverId = window.appEntityStore.getMappedServerIdFromLocalId( this.refugeeAnswerLocalResoureId );
    
    if( serverId === null ){
      return false;
    }
  
    return true;
  }

  
  /**
   * 
   * 
   * @param string answer "yes" or "no" or "unknown"
   * @returns 
   */
  createRefugeeQuestionResourceJson( answer ){
    let json = {
      "resourceType": "QuestionnaireResponse",
      "status": "completed",
      "questionnaire":"Questionnaire/user-refugee-status-v1", 
      "item": [
      ]
    };

    // maybe use valueBoolean instead? 
    // refugee from Ukraine?
    json.item.push( {
      "linkId": "ukraine.refugee",
      "text": "Refugee from Ukraine?",
      "answer": [
        {
          "valueString": answer
        }
      ]
    } );

    let items = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "Patient"
    });
    
    // thereshould be only 1 patient resource in store
    for( var ii in items ){
      let patientId = items[ ii ].getId();
      let pid = patientId.getResourceId();
      
      json.subject = {
        "reference" : "Patient/" + pid
      }
    }

    return json;
  }


  moveToNextQuestion( ){

    // check is the current question our fake refuree question before moving on to next one?
    let currentQuestion = window.qHolder.getCurrentQuestion();
    if( currentQuestion && typeof currentQuestion !== 'undefined' && typeof currentQuestion.questionLinkId !== 'undefined' ){
      this.maybeSendRefugeeAnswer( currentQuestion );
    }

    // if refugee question is answered "no" in "maybeSendRefugeeAnswer"- 
    // skip questionnaire and move to end instantly
    if( this.refugeeAnswerLastValue === 'no' ){
      this.props.handleNotRefugeeFinish();
      return;
    }

    window.qHolder.moveToNextQuestionInQueue();
    
    // historyandstate
    // console.log('FORWARD ADDED ');
    //var stateObj = { foo: "bar" };
    //history.pushState(stateObj, "-", "#q" + newQuestionNr );
    
    // if there is no ore questions - procceed to results instead
    if( window.qHolder.isQueueDone() ){
      this.requestHandleShowresults();
      return;
    }

    var newCnt = this.state.forceRenderCnt + 1;
    let newQuestionNr= this.state.questionNr + 1;
    
    this.setState({
      forceRenderCnt : newCnt,
      questionNr : newQuestionNr
    });
    
  }


  handleMoveBack( ){
    window.qHolder.moveToPreviousQuestionInQueue();

    var newCnt = this.state.forceRenderCnt + 1;
    
    this.setState({
      forceRenderCnt : newCnt
    });

  }


  handleFinishRequest( ){
    //if( typeof this.props.handleShowResults ){
    //  this.props.handleShowResults();
    //}

    this.requestHandleShowresults();

    /** 
    var newCnt = this.state.forceRenderCnt + 1;
    this.setState({
      finishRequested : true,
      forceRenderCnt : newCnt
    });
    */
  }


  requestHandleShowresults(){
    var that = this;

    if( this.guidanceResponseWaitTimer !== null ){
      clearTimeout( this.guidanceResponseWaitTimer );
      this.guidanceResponseWaitTimer = null;
    }

    if( typeof this.props.handleShowResults !== 'undefined' ){
      // Wait until have results and last results have loaded by 
      // listening to window.appLastGuidaneResesponse2.isWaiting 
      if( window.appLastGuidaneResesponse2.isWaiting || !window.appLastGuidaneResesponse2.hasRecievedGR ){
        this.guidanceResponseWaitTimer = setTimeout( function(){
          that.requestHandleShowresults();
        }, 50 );
        return;
      }
      this.props.handleShowResults();
    }

    return;
  }


  createFinishRequestQuestionJson(){

    let isAnsweredEnough = window.qHolder.isAnsweredEnough();
    
    let question = 'Are you really sure? There are not enough data to conclude or suggest anything. ';
    if( isAnsweredEnough ){
      question = 'Are you really sure?';
    }

    return {
      "linkId": "FAKE.1.1",
      "definition": "http://documental.ee/fhir/profile/questionnaire/item/scale1",
      "text": question,
      "type": "choice",
      "repeats": false,
      "answerOption": [{
          "valueCoding": {
            "code": "FAKE.1.1.A",
            "display": "I am sure"
          }
        }, {
          "valueCoding": {
            "code": "FAKE.1.1.D",
            "display": "I will resume"
          }
        }
      ]
    };
  }
  

  getFinishRequestAsQuestion( ){
    let json = this.createFinishRequestQuestionJson();
    return {
      'isCurrent' : true,
      'isPrevious' : false,
      'linkId' : json.linkId,
      'questionLinkId' : json.linkId,
      'question' : {
        'questionLinkId' : json.linkId,
        'questionJson' : json,
        'questionInSection' : null,
        'systemQuestion' : true
      }}
    ;
  }

  render() {
    
    var transPleaseWait = i18n.t( "Please wait" );
		let loadingTexts = [
			{
				"text" : transPleaseWait,
				"loader" : false
			},
			{
				"text" : '',
				"loader" : true
			},
		];
    
		let classNames1  = 'card-animate card-show';

    if( !this.state.resourcesLoaded ){
      return (
        <div className="cards-holder">
				  <div className={classNames1}>
					  <div className="mdl-card-wide mdl-card mdl-shadow--2dp;">
              <div className="mdl-card__supporting-text mdl-card--border">
                <br />
                <BotChatBubble botTexts={loadingTexts} />
              </div>
            </div>
          </div>
          
        </div>
      );
    }


    /**
     * 
     * QuestionnaireHolder <-> BotCompnent(Container) managing questions and showing, transfer events between Questionnaire and holder <-> Question ( no global events)
     * 
     * addQuestionAnswer
     *   if invalid question re-render
     * 
     * qHolder.getCurrentQuestion();
     *   qHolder.isFinished();
     * 
     * qHolder.addAnswer();
     * 
     * küsimused ei kuula muutusi
     * botComonent kuulab
     * 
     * Kõik tegevused peale küsimsue vastused
     * 
     * Uus questionnaireReponse serverist
     *   fire event questionnaireChanged
     *     BotCompnent picks it up (listens?)
     *       reRender currentQuestion?
     *         Yes
     *         No
     *      
     */



    let previousQuestion = window.qHolder.getPreviousQuestion();
    let currentQuestion = window.qHolder.getCurrentQuestion();
    
    if( previousQuestion ){
      //console.log( 'previousQuestion originally' );
      //console.log( previousQuestion );
    }
    //console.log( 'currentQuestion originally' );
    //console.log( currentQuestion );

    if( currentQuestion && typeof currentQuestion != 'undefined' ){
      currentQuestion.isResultsScreen = false;
    }

    let isAnsweredEnough = window.qHolder.isAnsweredEnough();
    let resultType = 'not-enough-info';
    if( isAnsweredEnough ){
      resultType = 'successful';
    }


    // overwrite actual questions with "are you sure" question
    if( this.state.finishRequested ){
      previousQuestion = window.qHolder.getCurrentQuestion();
      previousQuestion.isPrevious = true;
      previousQuestion.isCurrent = false;
      previousQuestion.isResultsScreen = false;
      currentQuestion = this.getFinishRequestAsQuestion();
      currentQuestion.isResultsScreen = false;
    } else if( window.qHolder.isQueueDone() || this.state.resultsScreen ) {
      //previousQuestion = window.qHolder.getCurrentQuestion();
      //previousQuestion.isPrevious = true;
      //previousQuestion.isCurrent = false;

      currentQuestion = {
        isPrevious : false,
        isCurrent : true,
        isResultsScreen : true,
        resultType: resultType
      };
    }

    ////// WTF they needed? Where is the leak :) ?
    //if( currentQuestion && typeof currentQuestion != 'undefined' ){
    //  currentQuestion.isCurrent = true;
    //  currentQuestion.isPrevious = false;
    //}
/*
    if( previousQuestion ){
      console.log( 'previousQuestion' );
      console.log( previousQuestion );
    }
    console.log( 'currentQuestion' );
    console.log( currentQuestion );
 */

    let questions = [];
    if( previousQuestion ){
      questions.push( previousQuestion );
    }
    questions.push( currentQuestion );

    var that = this;

    let progress = window.qHolder.getPercentageDone();

    /**
    let lf = "\n";
    var debuggerTexyt = 'Questions removed from upcoming list: ' + lf + lf;

    
    
    for( var j in window.qHolder.questionsQueue.skippedQuestions ){
      let questionA = window.qHolder.questionsQueue.skippedQuestions[ j ];
      // questionJson
      let opened = window.qHolder.isItemVisibleByOpenerRules( {
        linkId: questionA.question.questionLinkId
      } );
      let sample = questionA.question.questionJson.text.substr( 1, 15 );
      let linkId = questionA.question.questionLinkId;
      linkId = linkId.padEnd( 12, ' ' );
      debuggerTexyt = debuggerTexyt + linkId +  ' or: ' + (opened ? '1' : '0' )  + lf;
    }
    

    let LL = 0;
    for( var kky2 in window.qHolder.answersFlatList ){
      LL++;
    }
    debuggerTexyt = debuggerTexyt + lf + "AnswerList (for jsonLogic) L: " +  LL +  " : " + lf + '{' + lf ;

    let cnt = 1;
    for( var kky in window.qHolder.answersFlatList ){
      let comma = ',';
      if( cnt == LL ){
        comma = '';
      }
      cnt++;

      if (typeof window.qHolder.answersFlatList[ kky ] === "boolean"){
        debuggerTexyt = debuggerTexyt + '  "' + kky + '" : ' + window.qHolder.answersFlatList[ kky ] + comma + lf;
      } else {
        debuggerTexyt = debuggerTexyt + '  "' + kky + '" : "' + window.qHolder.answersFlatList[ kky ] + '"' + comma + lf;
      }
    }
    debuggerTexyt = debuggerTexyt + '}' + lf ;
     */
    
    return (
      <div className="cards-holder" key={this.state.forceRenderCnt}>
        
        {questions.map(function( queuedQuestion, index ){
          

          let cardDisplayState = 'initial';
          if( queuedQuestion != null && typeof queuedQuestion.isPrevious != 'undefined' && queuedQuestion.isPrevious ){
            cardDisplayState = 'closed';
          }

          let showProgressBar = false; 
          let canMoveBackwards = window.qHolder.canMoveBackwards();
          let canFinish = true;

          if( queuedQuestion == null || typeof queuedQuestion.questionLinkId == 'undefined' ){
            canFinish = false;
            canMoveBackwards = false;
            showProgressBar = false;
          }

          if( queuedQuestion != null && typeof queuedQuestion != 'undefined' && !queuedQuestion.isResultsScreen ){
            if( queuedQuestion.questionLinkId == 'FAKE.1.1' ){
              canFinish = false;
              canMoveBackwards = false;
              showProgressBar = false;
            }
          }
          showProgressBar = true;
          if( queuedQuestion != null && typeof queuedQuestion != 'undefined' && queuedQuestion.isResultsScreen ){

            return <BotQuestionnaireResult 
              key="results"
              isAnsweredEnough={queuedQuestion.isAnsweredEnough}
              cardDisplayState={cardDisplayState} 
              resultType={queuedQuestion.resultType}
            /> ;
            
          } else if( queuedQuestion != null && typeof queuedQuestion != 'undefined' && typeof queuedQuestion.questionLinkId != 'undefined' ) {

            let botMood = 'neutral';
            let moods = [ 
              'suprised',
              'waiting',
              'happy',
              'sad',
              'wink'
            ];

            if( queuedQuestion.questionLinkId == 'FAKE.1.1'  && !window.qHolder.isAnsweredEnough() ){
              if( queuedQuestion.isAnsweredEnough ){
                botMood = 'wink';
              } else {
                botMood = 'questioning';
              }
            } else {
              let rnd = Math.floor( Math.random() * 4 );
              // suprised waiting happy sad  questioning wink
              if( typeof moods[ rnd ] != 'undefined' ){
                botMood = moods[ rnd ];
              }
            }

            if( 'FAKE.1.1' == queuedQuestion.questionLinkId ){
              return <BotQuestionnaireResult 
                key="reults"
                isAnsweredEnough={true}
                canMoveBackwards={false}
                onMoveBack={that.handleMoveBack}
                onQuestionAnswered={that.handleQuestionAnswered}
                cardDisplayState={cardDisplayState} 
                botMood={botMood}
                resultType={resultType}
              /> ;
            } else {
              return <BotQuestion 
                key={queuedQuestion.questionLinkId} 
                queuedQuestion={queuedQuestion} 
                cardDisplayState={cardDisplayState} 
                onQuestionAnswered={that.handleQuestionAnswered}
                onFinishRequst={that.handleFinishRequest}
                onMoveBack={that.handleMoveBack}
                progress={progress} 
                canMoveBackwards={canMoveBackwards} 
                canFinish={canFinish} 
                showProgressBar={showProgressBar}
                botMood={botMood}
              /> ;
            }
          } else {
            return null;
          }

        })}

        {/*
        <div className="debug-area opened">
          <textarea cols="40" style={ {'width' : '100%', 'height' : '550px'} } defaultValue={debuggerTexyt}></textarea>
        </div>
        */}
      </div>
    );
  }

}

export default BotQuestionnaire;
